<template>
  <div class="container-fluid">
    <Panel Title=" درخواست وام" Des="در این منو میتوانید درخواست وام خود را ثبت نمایید." :IsBtnBack="true" ClassCustom="bg-dark-Custom text-right mt-2"></Panel>
    <net-pa-card>
      <template slot="header">
        <h6 class="text-right"><i class="fas fa-hand-holding-usd"></i> درخواست وام</h6>
      </template>
      <template slot="content">
        <div class="row">
          <div @click="nextPage(1)" class="col-12 col-md-2 border current bnp-rounded text-right hoverHeader mr-1 pr-3 p-2">
            <a class="d-block w-100 h-100" id="head1"> انتخاب نوع وام</a>
          </div>
          <div @click="nextPage(2)" v-if="Object.entries(SelectedVam).length != 0" class="col-12 col-md-2 border bnp-rounded text-right hoverHeader mr-1 pr-3 p-2">
            <a class="d-block w-100 h-100" id="head2"> اطلاعات تکمیلی</a>
          </div>
          <div @click="nextPage(2)" v-else class="col-12 col-md-2 border bnp-rounded text-right mr-1 pr-3 p-2">
            <a class="d-block w-100 h-100" id="head2" title="ابتدا نوع وام را مشخص کنید"> اطلاعات تکمیلی</a>
          </div>
          <div @click="nextPage(3)" v-if="vamDetail.Mablaghghest == 0 || vamDetail.MablaghVam == 0" class="col-12 col-md-2 border bnp-rounded text-right mr-1 pr-3 p-2">
            <a class="d-block w-100 h-100" id="head3" title="لطفا اطلاعات وام را تکمیل کنید"> مشخصات ضامنین</a>
          </div>
          <div @click="nextPage(3)" v-else class="col-12 col-md-2 border bnp-rounded text-right hoverHeader mr-1 pr-3 p-2">
            <a class="d-block w-100 h-100" id="head3"> مشخصات ضامنین</a>
          </div>

          <div @click="nextPage(4)" class="col-12 col-md-2 border bnp-rounded text-right hoverHeader mr-1 pr-3 p-2">
            <a class="d-block w-100 h-100" id="head4"> آپلود مدارک</a>
          </div>
          <div class="col-md-3 col-12 border bnp-rounded text-right hoverHeader mr-1 pr-3 p-2">
            <a class="d-block w-100 h-100" id="head5"> تایید نهایی</a>
          </div>
        </div>
        <div class="row mt-3 px-2">
          <div v-if="divToShow == 1" class="col-12 border bnp-rounded">
            <div v-for="(item, key) in Vamha" :key="key" class="row px-3">
              <div class="col-3"></div>
              <div class="col-12 col-md-6 mt-2 p-2">
                <div class="w-100 border bnp-rounded Netpa-Shadow p-2">
                  <div class="row">
                    <div class="col-6 text-right">
                      <span class="text-secondary">نام تسهیلات: </span>
                      <span class="text-dark font-weight-bold">{{ item.desNoe }}</span>
                    </div>

                    <div class="col-6 text-left">
                      <button v-if="SelectedVam.id != item.id" @click="seLectVam(item)" class="btn NetPa-btn btn-primary">انتخاب</button>
                      <span v-else class="text-success font-weight-bold"> انتخاب شده <i class="fas fa-check"></i></span>
                    </div>
                    <div class="col-12 mt-1 text-right">
                      <span class="text-secondary">{{ item.des }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-3"></div>
            </div>
            <div class="row my-2 px-3">
              <div class="col-3"></div>
              <div class="col-3"></div>
              <div class="col-3"></div>
              <div class="col-12 col-md-3">
                <button :disabled="Object.entries(SelectedVam).length === 0" @click="nextPage(2)" class="btn btn-success w-100 NetPa-btn">مرحله بعد</button>
              </div>
            </div>
          </div>
          <div v-if="divToShow == 2" class="col-12 border bnp-rounded">
            <div class="row">
              <div class="col-3"></div>
              <div class="col-md-6 col-12 row">
                <div class="col-md-6 py-2 col-12">
                  <label for="MabVam" class="text-secondary"> مبلغ وام</label>
                  <input
                    type="text"
                    id="MabVam"
                    class="form-control text-left 3ragham"
                    v-model="vamDetail.MablaghVam"
                    @keypress="$ValidNumber($event, 15, false)"
                    @keyup="$PutCommatoInput()"
                    @blur="
                      handleMablagh($event)
                      calculateMablaghghest()
                      UpdateZamenPolicy()
                    "
                    dir="ltr"
                  />
                </div>
                <div class="col-md-6 py-2 col-12">
                  <span class="text-secondary text-weight-normal">تاریخ درخواست</span>
                  <date-picker disabled v-model="vamDetail.NeedData" color="#f38905"></date-picker>
                  <input type="text" id="NeedData" v-model="vamDetail.NeedData" class="d-none InputText" dir="ltr" />
                </div>
                <div class="col-md-6 py-2 col-12">
                  <label for="ghestNum" class="text-secondary"> تعداد قسط</label>
                  <input
                    type="text"
                    id="ghestNum"
                    v-model="vamDetail.TedadGhest"
                    class="form-control text-left"
                    @blur="
                      handleTedad($event)
                      calculateMablaghghest()
                      UpdateZamenPolicy()
                    "
                    maxlength="3"
                    @keypress="$ValidNumber($event, 12, false)"
                    dir="ltr"
                  />
                </div>
                <div class="col-md-6 py-2 col-12">
                  <label for="ghestmab" class="text-secondary"> مبلغ قسط</label>
                  <input disabled="disabled" type="text" id="ghestmab" v-model="vamDetail.Mablaghghest" class="form-control text-left 3ragham" />
                </div>
                <div class="col-md-6 py-2 col-12">
                  <label class="text-secondary"> نحوه پرداخت وام</label>
                  <select v-model="nahvepardakht" class="form-control Pointer">
                    <option value="4014">واریز به حساب بانکی</option>
                    <option selected value="4015">واریز به حساب پس انداز</option>
                  </select>
                </div>
                <div class="col-md-6 py-2 col-12">
                  <span v-if="nahvepardakht == 4015">
                    <label class="text-secondary">انتخاب حساب پس انداز </label>
                    <select class="form-control Pointer" v-model="NahveVarizDetail">
                      <option v-for="item in ListTaahodat" :key="item.id" :value="item.id">{{ item.desNoe }}</option>
                    </select>
                  </span>
                  <span v-if="nahvepardakht == 4014">
                    <label class="text-secondary">انتخاب حساب بانکی </label>
                    <select class="form-control Pointer" v-model="NahveVarizDetail">
                      <option v-for="item in ListAzaHesab" :key="item.id" :value="item.id">{{ item.bankName }} -- {{ item.hesabNo }}</option>
                    </select>
                  </span>
                </div>
              </div>
              <div class="col-3"></div>
            </div>
            <div class="row mb-2">
              <div class="col-6">
                <ul>
                  <li v-if="SelectedVam.minMablagh > 0" class="text-warning h6">
                    <small> حداقل مبلغ قابل درخواست {{ this.$Comma3ragham(SelectedVam.minMablagh) }} {{ $cookies.get('VahedPool') }} </small>
                  </li>
                  <li v-if="SelectedVam.maxMablagh > 0" class="text-warning h6">
                    <small> حداکثر مبلغ قابل درخواست {{ this.$Comma3ragham(SelectedVam.maxMablagh) }} {{ $cookies.get('VahedPool') }} </small>
                  </li>
                  <li v-if="SelectedVam.minTedad > 0" class="text-warning h6">
                    <small> حداقل تعداد قسط درخواستی {{ this.$Comma3ragham(SelectedVam.minTedad) }} </small>
                  </li>
                  <li v-if="SelectedVam.maxTedad > 0" class="text-warning h6">
                    <small> حداکثر تعداد قسط درخواستی {{ this.$Comma3ragham(SelectedVam.maxTedad) }} </small>
                  </li>
                </ul>
                <hr />
                شرایط دریافت تسهیلات
                <br />
                <ul>
                  <li class="text-info h6 mt-2">
                    <p v-for="line in lines" :key="line">{{ line }}</p>
                  </li>
                </ul>
              </div>
              <div class="col-3"></div>
              <div class="col-12 col-md-3">
                <button :disabled="isValidTedad == true && isValidMablaghVam == true ? false : 'disabled'" @click="nextPage(3)" class="btn btn-success my-2 w-100 NetPa-btn">مرحله بعد</button>
              </div>
            </div>
          </div>
          <div v-if="divToShow == 3" class="col-12 border bnp-rounded">
            <div class="row">
              <div class="col-3"></div>
              <div class="col-12 col-md-6">
                <div v-for="(item, key) in ListNoePolicyFilter.tedad" :key="key" class="col-12 row my-3">
                  <div class="col-12 col-md-1"></div>
                  <div class="col-10 col-md-8">
                    <input type="number" class="form-control text-center" dir="ltr" v-model="ListCodeMeli[key]" :placeholder="key + 1 + ' کد ملی ضامن '" />
                  </div>
                  <div class="col-2 col-md-2">
                    <button class="btn btn-success" @click="GetZament(key)">استعلام</button>
                    <button class="d-none" id="ZamenModal" data-toggle="modal" data-target="#Modal-Orange">modal</button>
                  </div>
                </div>
                <div v-for="(item, index) in ListZamen" :key="index">
                  <div class="col-12 col-md-1"></div>
                  <div class="col-12 col-md-1"></div>
                  <div class="col-10 col-md-10 my-2 border border-success rounded p-2">
                    <div class="w-100">
                      <span class="text-secondary">نام ضامن {{ index + 1 }} :</span>
                      <span class="text-dark">
                        {{ item.NameFamily }}
                      </span>
                      <span class="float-left"
                        ><a href="javascript:;" class="mr-2 badge" @click="OnDelete(item.CodeMeli)">
                          <i class="fa fa-trash-alt text-secondary hover-dange"></i>
                        </a>
                      </span>
                    </div>
                  </div>
                  <div class="col-12 col-md-1"></div>
                </div>
              </div>
              <div class="col-3"></div>
            </div>
            <div class="row mb-2">
              <div class="col-3"></div>
              <div class="col-3"></div>
              <div class="col-3"></div>
              <div class="col-12 col-md-3">
                <button :disabled="vamDetail.Mablaghghest == 0 || vamDetail.MablaghVam == 0" @click="nextPage(4)" class="btn btn-success my-2 w-100 NetPa-btn">مرحله بعد</button>
              </div>
            </div>
          </div>
          <div v-if="divToShow == 4" class="col-12 border bnp-rounded">
            <div v-if="SelectedVam.isUpload" class="row">
              <div class="col-md-3"></div>
              <div class="col-md-6 col-12 p-4 row">
                <div class="col-12">
                  <div v-if="$cookies.isKey('DownloadForm')" class="w-100 p-4 row yellowback mb-2 text-center" style="height: 10vh">
                    <h6>
                      برای دانلود فرم درخواست وام <a :href="$cookies.get('DownloadForm')" download="فرم درخواست وام"><sapn class="badge badge-success">اینجا</sapn></a> کلیک کنید.
                    </h6>
                  </div>
                </div>
                <div class="col-12">
                  <div class="w-100 p-4 row border-dotted blueback" style="height: 25vh">
                    <div class="col-6 h-100">
                      <input type="file" id="attachmentUploader" @change="changeattach" class="d-none" />
                      <button class="btn btn-primary m-4 Netpa-btn" @click="clickUploader" style="margin: auto">بارگذاری فایل</button>
                    </div>
                    <div class="col-6 row h-100">
                      <div class="col-12 text-center">
                        <span>
                          <i class="fas fa-file text-primary" style="font-size: 50px !important"></i>
                        </span>
                      </div>
                      <span v-if="attachment">
                        <div class="col-12">
                          <span class="text-secondary my-3">نام فایل:</span>
                          <span class="text-dark">{{ attachment.name }}</span>
                        </div>
                        <div class="col-12 my-3">
                          <span class="text-secondary">حجم فایل:</span>
                          <span class="text-dark"> KB {{ attachment.size / 1000 }} </span>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-3"></div>
            </div>
            <div class="row mb-2">
              <div class="col-3"></div>
              <div v-if="SelectedVam.isUpload" class="col-6">
                <hr />
                شرایط آپلود مدارک تسهیلات
                <br />
                <ul>
                  <li class="text-info h6 mt-2">
                    <p v-for="line in linesattachment" :key="line">{{ line }}</p>
                  </li>
                </ul>
              </div>
              <div v-else class="col-6">
                <ul>
                  <li class="text-info h6 mt-2">
                    <p>{{ 'مدارکی برای این نوع تسهیلات برای آپلود نیاز نیست' }}</p>
                  </li>
                </ul>
              </div>
              <div class="col-12 col-md-3">
                <button v-if="SelectedVam.isUpload && attachment != null" @click="nextPage(5)" class="btn btn-success my-2 w-100 NetPa-btn">مرحله بعد</button>
                <button v-else-if="!SelectedVam.isUpload" @click="nextPage(5)" class="btn btn-success my-2 w-100 NetPa-btn">مرحله بعد</button>
                <button v-else disabled class="btn btn-success my-2 w-100 NetPa-btn">مرحله بعد</button>
              </div>
            </div>
          </div>

          <div v-if="divToShow == 5" class="col-12 border bnp-rounded">
            <div class="w-100 p-2">
              <h4 style="font-size: 15px" class="font-weight-bold">تایید نهایی درخواست</h4>
              <hr />
            </div>
            <div class="row border-right border-primary my-1 mx-3" style="border-right: 3px solid #007bff !important">
              <div class="col-12 m-2 border-bottom">
                <h6>مشخصات وام</h6>
              </div>
              <div class="col-md-6 col-12 my-1">
                <span class="text-secondary font-weight-bold"> نام تسهیلات درخواستی:</span>
                <span class="text-dark"> {{ SelectedVam.desNoe }} </span>
              </div>
              <div class="col-md-6 col-12 my-1">
                <span class="text-secondary font-weight-bold"> مبلغ درخواستی :</span>
                <span class="text-dark"> {{ $Comma3ragham(vamDetail.MablaghVam) }} {{ $cookies.get('VahedPool') }}</span>
              </div>
              <div class="col-md-6 col-12 my-1" v-if="this.$session.get('CustCode') != 9">
                <span class="text-secondary font-weight-bold"> مبلغ هر قسط :</span>
                <span class="text-dark"> {{ $Comma3ragham(vamDetail.Mablaghghest) }} {{ $cookies.get('VahedPool') }}</span>
              </div>
              <div class="col-md-6 col-12 my-1">
                <span class="text-secondary font-weight-bold"> تعداد قسط :</span>
                <span class="text-dark"> {{ vamDetail.TedadGhest }} </span>
              </div>
              <div class="col-md-6 col-12 my-1">
                <span class="text-secondary font-weight-bold"> تاریخ دخواست وام:</span>
                <span class="text-dark"> {{ vamDetail.NeedData }} </span>
              </div>
            </div>
            <!-- <div class="w-100 border my-3 border-success">
              {{ ListZamen }}
            </div> -->
            <div class="row border-right border-success mt-3 mx-3" style="border-right: 3px solid #28a745 !important">
              <div class="col-12 m-2 border-bottom">
                <h6>مشخصات ضامنین</h6>
              </div>
              <div class="col-12 border rounded m-2">
                <div v-for="(item, key) in ListZamen" :key="key" class="row">
                  <div class="col-12 m-2">
                    <span class="font-weight-bold font-weight-bold">مشخصات ضامن {{ key + 1 }}</span>
                  </div>
                  <div class="col-md-4 col-12">
                    <span class="text-secondary"> نام نام خانوادگی: </span>
                    <span>{{ item.NameFamily }}</span>
                  </div>
                  <div class="col-md-4 col-12">
                    <span class="text-secondary font-weight-bold"> کدملی: </span>
                    <span>{{ item.CodeMeli }}</span>
                  </div>
                  <div class="col-md-4 col-12">
                    <span class="text-secondary font-weight-bold"> نام پدر: </span>
                    <span>{{ item.Pedar }}</span>
                  </div>
                  <div class="col-md-4 col-12">
                    <span class="text-secondary font-weight-bold"> شماره تماس: </span>
                    <span>{{ item.Tel }}</span>
                  </div>
                  <div class="col-md-4 col-12">
                    <span class="text-secondary font-weight-bold"> شماره همراه: </span>
                    <span>{{ item.Mobile }}</span>
                  </div>
                  <div class="colmd-6 col-12">
                    <span class="text-secondary font-weight-bold"> آدرس: </span>
                    <span>{{ item.Adres }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row border-right border-danger mt-3 mx-3" style="border-right: 3px solid #dc3545 !important">
              <div class="col-12 m-2 border-bottom">
                <h6>مشخصات فایلها</h6>
              </div>

              <div v-if="attachment" class="col-12">
                <div class="row">
                  <div class="col-md-6 col-12">
                    <span class="text-secondary">نام فایل: </span>
                    <span>{{ attachment.name }}</span>
                  </div>
                  <div class="col-md-6 col-12">
                    <span class="text-secondary">حجم فایل: </span>
                    <span>{{ attachment.size / 1000000 }} Mb</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row my-3">
              <div class="col-md-4 col-12"></div>
              <div class="col-md-4 col-12"></div>
              <div class="col-md-4 col-12">
                <button @click="FinalSubmit" class="btn btn-success w-100 NetPa-btn">ثبت نهایی درخواست</button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </net-pa-card>
  </div>
</template>
<
<script>
import Panel from '../Tools/NetPa/Panel.vue'
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'

export default {
  data() {
    return {
      ListNoePolicy: null,
      ListNoePolicyFilter: null,
      lines: [],
      linesattachment: [],
      SelectedVam: {},
      // vamDetail: {
      //     id: 0,
      //     des: '',
      //     desNoe: '' ,
      //     desUpload: '',
      //     isActive: true,
      //     minMablagh: 0,
      //     maxMablagh: 0,
      //     isformula: false,
      //     minTedad: 1,
      //     maxTedad: 36,
      //     isUpload: false,
      //     isSafteElectronic: false,
      //     NeedData:''
      // },
      nahvepardakht: 4015,
      NahveVarizDetail: null,
      DataAxiosTaahodat: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxiosAzaHesab: {
        ArryfildValue: '',
        Method: 'Get',
        Action: 'AzaHesab',
        Token: this.$session.get('TokenNetPa'),
      },
      ListTaahodat: [],
      ListAzaHesab: [],
      vamDetail: {
        Mablaghghest: 0,
        TedadGhest: 24,
        MablaghVam: 0,
        NeedData: '',
      },
      isValidMablaghVam: false,
      isValidTedad: false,
      divToShow: 1,
      Vamha: [],
      DataAxiosGetNoeVam: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'RequestVamNew/SelTozihatRequest',
        Token: this.$session.get('TokenNetPa'),
      },
      DataActionVamCondition: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'RequestVamNew/VamCondition',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxiosZamenPolicy: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'RequestVamNew/GetZamenPolicyOnline',
        Token: this.$session.get('TokenNetPa'),
      },
      ListCodeMeli: [],
      ListZamen: [],
      attachment: null,
    }
  },
  components: { Panel, NetPaCard },
  mounted() {
    this.vamDetail.NeedData = this.$GetJalaliDate()
    this.GetNoeVam()
  },
  methods: {
    FinalSubmit() {
      console.log(this.ListZamen)
      console.log(this.ListCodeMeli)
      var formdata = new FormData()
      console.log("😎 ~ FinalSubmit ~ this.ListZamen:", this.ListZamen)

      
      this.vamDetail.MablaghVam = this.vamDetail.MablaghVam.replaceAll(',', '')

      formdata.append('NahveVarizDetail', this.NahveVarizDetail)
      formdata.append('WwwtblcomboIdNahveVarizGrp7', this.nahvepardakht)
      formdata.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formdata.append('RequestTarix', this.$store.state.JalaliDate)
      formdata.append('Mablagh', this.vamDetail.MablaghVam)
      formdata.append('MablaghTavanaiePardakht', this.vamDetail.MablaghVam)
      formdata.append('TedadGhest', this.vamDetail.TedadGhest)
      formdata.append('NeedTarix', this.vamDetail.NeedData)
      formdata.append('CodeMeliZamenAsli', this.ListCodeMeli != null ? this.ListCodeMeli[0] : '')
      formdata.append('CodeMeliZamenFarei', this.ListCodeMeli != null && this.ListCodeMeli.length > 1 ? this.ListCodeMeli[1] : '')
      formdata.append('NameFamilyZamenAsli', this.ListZamen.length == 0 ? '' : this.ListZamen[0].NameFamily)
      formdata.append('CodeMeliMoaref', this.ListCodeMeli != null && this.ListCodeMeli.length > 2 ? this.ListCodeMeli[2] : '')
      formdata.append('PedarZamenAsli', this.ListZamen.length == 0 ? '' : this.ListZamen[0].Pedar)
      formdata.append('TelZamenAsli', this.ListZamen.length == 0 ? '' : this.ListZamen[0].Tel)
      formdata.append('MobileZamenAsli', this.ListZamen.length == 0 ? '' : this.ListZamen[0].Mobile)
      formdata.append('AdresZamenAsli', this.ListZamen.length == 0 ? '' : this.ListZamen[0].Adres)
      formdata.append('MobileZamenFarei', this.ListZamen.length != 0 && this.ListZamen.length > 1 ? this.ListZamen[1].Mobile : '')
      formdata.append('AdresZamenFarei', this.ListZamen.length != 0 && this.ListZamen.length > 1 ? this.ListZamen[1].Adres : '')
      formdata.append('TelZamenFarei', this.ListZamen.length != 0 && this.ListZamen.length > 1 ? this.ListZamen[1].Tel : '')
      formdata.append('PedarZamenFarei', this.ListZamen.length != 0 && this.ListZamen.length > 1 ? this.ListZamen[1].Pedar : '')
      formdata.append('NameFamilyZamenFarei', this.ListZamen.length != 0 && this.ListZamen.length > 1 ? this.ListZamen[1].NameFamily : '')
      formdata.append('ShoghlZamenAsli', this.ListZamen.length == 0 ? '' : this.ListZamen[0].Job)
      formdata.append('ShoghlZamenFarei', this.ListZamen.length != 0 && this.ListZamen.length > 1 ? this.ListZamen[1].Job : '')
      formdata.append('ShoglMoaref', this.ListZamen.length != 0 && this.ListZamen.length > 2 ? this.ListZamen[2].Job : '')
      formdata.append('AdresMoaref', this.ListZamen.length != 0 && this.ListZamen.length > 2 ? this.ListZamen[2].Adres : '')
      formdata.append('MobileMoaref', this.ListZamen.length != 0 && this.ListZamen.length > 2 ? this.ListZamen[2].Mobile : '')
      formdata.append('TellMoaref', this.ListZamen.length != 0 && this.ListZamen.length > 2 ? this.ListZamen[2].Tel : '')
      formdata.append('PedarMoaref', this.ListZamen.length != 0 && this.ListZamen.length > 2 ? this.ListZamen[2].Pedar : '')
      formdata.append('NameFamiliMoaref', this.ListZamen.length != 0 && this.ListZamen.length > 2 ? this.ListZamen[2].NameFamily : '')
      formdata.append('AzaIdMoaref', this.ListZamen.length != 0 && this.ListZamen.length > 2 ? this.ListZamen[2].Id : '')
      formdata.append('AzaIdZamenFarei', this.ListZamen.length != 0 && this.ListZamen.length > 1 ? this.ListZamen[1].Id : '')
      formdata.append('AzaIdZamen', this.ListZamen.length == 0 ? '' : this.ListZamen[0].Id)
      formdata.append('IsTaeidVam', 0)
      formdata.append('wwwtblNoeId', this.SelectedVam.id)
      if (this.attachment) {
        formdata.append('file', this.attachment)
      }
      var DataAxiosSubmit = {
        ArryfildValue: formdata,
        Method: 'Post',
        Action: 'InsNewVam',
        Token: this.$session.get('TokenNetPa'),
      }

      this.$PostFormData(DataAxiosSubmit)
        .then((data) => {
          if (data.success == 'SUCCESS') {
            this.needVamId = data.needVamId
            //اگر needVamId پر بود فایل هارو بفرستیم
            if (this.$session.get('CustCode') == 868) {
              if (this.FileHokm868 != null && this.FileZamenanat868 != null && this.FileGhardad868 != null) {
                var formdataAtach = new FormData()
                formdataAtach.append('needVamId', this.needVamId)
                formdataAtach.append('FileHokm868', this.FileHokm868)
                formdataAtach.append('FileZamenanat868', this.FileZamenanat868)
                formdataAtach.append('FileGhardad868', this.FileGhardad868)
                var axios = { Method: 'POST', Action: 'InsNewVam/Atachment868', ArryfildValue: formdataAtach, Token: this.$session.get('TokenNetPa') }
                this.$PostFormData(axios).then((res) => {})
              } else {
                this.$mySweetDefaultTost('خطا', 'لطفا تمامی فایل های خواسته شده را آپلود نمایید ', 'warning', 2000)
              }
            }
            this.$mySweetDefault('عملیات موفق', 'درخواست وام شما با کد رهگیری ' + data.codeRahgiri + ' در سیستم ثبت شد.', 'success', 2500)
            this.$router.push('loanFollowup')
          } else {
            this.needVamId = 0
            this.$mySweetDefault('عملیات ناموفق', 'درخواست شما در سیستم ثبت نشد.' + data.codeRahgiri + ' در سیستم ثبت شد.', 'warning', 2500)
          }
        })
        .catch((error) => {
          this.$mySweetDefault('عملیات ناموفق', 'مشکلی بوجود آمده است. دوباره تلاش کنید', 'error', 2500)
          this.needVamId = 0
          console.warn(error)
        })
    },
    OnDelete(data) {
      for (let index = 0; index < this.ListZamen.length; index++) {
        if (this.ListZamen[index].CodeMeli == data) {
          this.ListZamen.splice(index, 1)
        }
      }
    },
    GetZament(number) {
      // console.log('number',number);
      if (this.$session.get('UserInfoNetPa').codeMeli.trim() == this.ListCodeMeli[number]) {
        this.$mySweetDefault('خطا', 'شما کد ملی خود را وارد کرده اید', 'error', 2000)
        return
      }
      if (this.ListCodeMeli[number].length < 10) {
        this.$mySweetDefault('خطا', ' طول کد ملی نمیتواند کمتر از 10 رقم باشد', 'error', 2000)
      } else {
        var DataAxiosGetZament = {
          ArryfildValue: '',
          Method: 'Post',
          Action: 'GetZamenByMelli3Onlione',
          Token: this.$session.get('TokenNetPa'),
        }
        var formdata = new FormData()
        formdata.append('wwwtblShobeId', this.$session.get('UserInfoNetPa').wwwtblShobeId)
        formdata.append('CodeMeli', this.ListCodeMeli[number])
        DataAxiosGetZament.ArryfildValue = formdata
        this.$PostFormData(DataAxiosGetZament).then((data) => {
          // console.log(data);
          if (data != null) {
            if (data.success && data.success == 'Failed') {
              // if (this.ListNoePolicyFilter.isOzv) {
                //وقتی که عضویت ضامن اجباری باشد
              // }
              this.$mySweetDefault('خطا', data.message, 'error', 3500)
              console.log(this.ListNoePolicyFilter);
            } else if (data.mandeZemanat != null) {
              if (data.mandeZemanat >= Number(this.vamDetail.MablaghVam.replace(/\,/g, ''))) {
                //مبلغ وام کمتر از سقف ضمانت می باشد
                if (this.ListZamen.length == 0) {
                  this.ListZamen.push({ Tel: data.tel, Pedar: data.pedar, NameFamily: data.nameFamily, Mobile: data.mobile, Adres: data.adres, Id: data.id, CodeMeli: this.ListCodeMeli[number] })
                  return
                } else {
                  for (let index = 0; index < this.ListZamen.length; index++) {
                    if (this.ListZamen[index].CodeMeli == this.ListCodeMeli[number]) {
                      this.$mySweetDefault('هشدار', 'ضامن تکراری است', 'warning', 2000)
                      return
                    } else {
                      this.ListZamen.push({ Tel: data.tel, Pedar: data.pedar, NameFamily: data.nameFamily, Mobile: data.mobile, Adres: data.adres, Id: data.id, CodeMeli: this.ListCodeMeli[number] })
                      return
                    }
                  }
                }
              } else {
                this.$mySweetDefault('خطا', 'ضامن وارد شده به سقف ضمانت خود رسیده ، لطفا ضامن دیگری انتخاب نمایید', 'error', 3500)
              }
            } else {
              if (this.ListZamen.length == 0) {
                if (this.ListNoePolicyFilter.maxCountForZemanat == 0){
                  this.ListZamen.push({ Tel: data.tel, Pedar: data.pedar, NameFamily: data.nameFamily, Mobile: data.mobile, Adres: data.adres, Id: data.id, CodeMeli: this.ListCodeMeli[number] })
                  return
                }
                else{
                  if (data.countZemanat < this.ListNoePolicyFilter.maxCountForZemanat) {
                    this.ListZamen.push({ Tel: data.tel, Pedar: data.pedar, NameFamily: data.nameFamily, Mobile: data.mobile, Adres: data.adres, Id: data.id, CodeMeli: this.ListCodeMeli[number] })
                    return
                  } else {
                    this.$mySweetDefaultTost('هشدار', 'ضامن وارد شده به سقف ضمانت رسیده ، لطفا ضامن دیگری انتحاب نمایید', 'warning', 2000)
                    return
                  }
                }
              } else {
                for (let index = 0; index < this.ListZamen.length; index++) {
                  if (this.ListZamen[index].CodeMeli == this.ListCodeMeli[number]) {
                    this.$mySweetDefault('هشدار', 'ضامن تکراری است', 'warning', 2000)
                    return
                  } else {
                    if (this.ListNoePolicyFilter.maxCountForZemanat == 0) {
                      this.ListZamen.push({ Tel: data.tel, Pedar: data.pedar, NameFamily: data.nameFamily, Mobile: data.mobile, Adres: data.adres, Id: data.id, CodeMeli: this.ListCodeMeli[number] })
                        return
                    } else {
                      if (data.countZemanat < this.ListNoePolicyFilter.maxCountForZemanat) {
                        this.ListZamen.push({ Tel: data.tel, Pedar: data.pedar, NameFamily: data.nameFamily, Mobile: data.mobile, Adres: data.adres, Id: data.id, CodeMeli: this.ListCodeMeli[number] })
                        return
                      } else {
                        this.$mySweetDefaultTost('هشدار', 'ضامن وارد شده به سقف ضمانت رسیده ، لطفا ضامن دیگری انتحاب نمایید', 'warning', 2000)
                        return
                      }
                    }
                  }
                }
              }
            }
          }
        })
      }
    },
    handleMablagh(event) {
      const inputValue = Number(event.target.value.replace(/,/g, '').replace(/\./g, ''))
      if (inputValue == NaN) {
        this.$mySweetDefault('هشدار', 'مقدار مبلغ درخواستی معتبر نمیباشد', 'warning', 3000)
        this.isValidMablaghVam = 'false'
        return false
      }

      if (inputValue < Number(this.SelectedVam.minMablagh) && Number(this.SelectedVam.minMablagh) > 0) {
        this.$mySweetDefault('هشدار', 'مقدار حداقل مبلغ درخواستی رعایت نشده است', 'warning', 3000)
        this.isValidMablaghVam = false
        return false
      }
      if (inputValue > Number(this.SelectedVam.maxMablagh) && Number(this.SelectedVam.maxMablagh) > 0) {
        this.$mySweetDefault('هشدار', 'مقدار حداکثر مبلغ درخواستی رعایت نشده است', 'warning', 3000)
        this.isValidMablaghVam = false
        return false
      } else this.isValidMablaghVam = true
    },
    handleTedad(event) {
      const inputValue = Number(event.target.value)

      if (inputValue < Number(this.SelectedVam.minTedad) && Number(this.SelectedVam.minTedad) > 0) {
        this.$mySweetDefault('هشدار', 'مقدار حداقل تعداد قسط درخواستی رعایت نشده است', 'warning', 3000)
        this.isValidTedad = false
        return false
      }

      if (inputValue > Number(this.SelectedVam.maxTedad) && Number(this.SelectedVam.maxTedad) > 0) {
        this.$mySweetDefault('هشدار', 'مقدار حداکثر تعداد قسط درخواستی رعایت نشده است', 'warning', 3000)
        this.isValidTedad = false
        return false
      } else this.isValidTedad = true
    },
    calculateMablaghghest(e) {
      if (this.SelectedVam.isformula && (this.$session.get('CustCode') == 868 || this.$session.get('CustCode') == 920)) {
        var formdata = new FormData()
        formdata.append('wwwtblNoeId', this.SelectedVam.id)
        formdata.append('MabDarkhastVam', Number(this.vamDetail.MablaghVam.replace(/,/g, '')))
        formdata.append('TedadGhest', this.vamDetail.TedadGhest)
        formdata.append('TarixDarkhast', this.vamDetail.NeedData)
        var DataAxios = {
          ArryfildValue: formdata,
          Method: 'Post',
          Action: 'InsNewVam/CalcKarmozd',
          Token: this.$session.get('TokenNetPa'),
        }
        this.$PostFormData(DataAxios).then((res) => {
          this.vamDetail.Mablaghghest = (res.data[0].karmozdBimeSood + Number(this.vamDetail.MablaghVam.replace(/,/g, ''))) / this.vamDetail.TedadGhest
          this.vamDetail.Mablaghghest = Math.round(this.vamDetail.Mablaghghest)
          this.vamDetail.Mablaghghest = this.vamDetail.Mablaghghest + ''
          this.vamDetail.Mablaghghest = this.$session.get('CustCode') == 868?this.$Comma3ragham(Number(this.vamDetail.Mablaghghest.replace(/\d{4}$/, '0000'))):this.$Comma3ragham(Number(this.vamDetail.Mablaghghest))
        })
      }
      else{
        if (this.SelectedVam.TedadGhest == 0) {
          this.vamDetail.Mablaghghest = 0
        } else {
          this.vamDetail.Mablaghghest = Number(this.vamDetail.MablaghVam.replaceAll(/,/g, '')) > 0 ? this.$Comma3ragham(Math.round(Number(this.vamDetail.MablaghVam.replaceAll(/,/g, '')) / this.vamDetail.TedadGhest)) : 0
        }
      }
    },
    selectCurent(data, number) {
      var headers = document.getElementsByClassName('hoverHeader')
      for (let index = 0; index < headers.length; index++) {
        const element = headers[index]
        element.classList.remove('current')
      }
      if (data.target) {
        data.target.parentNode.classList.add('current')
      } else {
        data.parentNode.classList.add('current')
      }
      this.divToShow = number
    },
    nextPage(number) {
      if (number == 2) {
        const formData = new FormData()
        formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
        formData.append('wwwtblSarfaslTypeId', 2)
        this.DataAxiosTaahodat.ArryfildValue = formData
        this.$PostFormData(this.DataAxiosTaahodat).then((data) => {
          this.ListTaahodat = data
        })

        this.DataAxiosAzaHesab.ArryfildValue = { Id: this.$session.get('UserInfoNetPa').wwwtblAzaId }
        this.$GetData_Header(this.DataAxiosAzaHesab).then((data) => {
          this.ListAzaHesab = data
        })
      }
      if (number == 3) {
        if (this.isValidTedad == false || this.isValidMablaghVam == false) {
          return
        }
      }
      if (number == 4) {
          if (this.ListNoePolicyFilter.tedad!=undefined) {            
            if (this.ListZamen.length != this.ListNoePolicyFilter.tedad) {
              this.$mySweetDefaultTost('عدم تکمیل ضامنین', 'اطلاعات هر ' + this.ListNoePolicyFilter.tedad + ' ضامن باید تکمیل شوند', 'warning', 1500)
              return
            }
          }
      }
      this.selectCurent(document.getElementById('head' + number), number)
    },
    GetNoeVam() {
      var formdata = new FormData()
      this.$PostFormData(this.DataAxiosGetNoeVam).then((data) => {
        this.Vamha = data
      })
    },
    UpdateZamenPolicy() {
      this.ListNoePolicyFilter = []
      if (this.ListNoePolicy != null) {
        for (let index = 0; index < this.ListNoePolicy.length; index++) {
          if (Number(this.vamDetail.MablaghVam.replace(/,/g, '').replace(/\./g, '')) >= this.ListNoePolicy[index].mabAz && Number(this.vamDetail.MablaghVam.replace(/,/g, '').replace(/\./g, '')) <= this.ListNoePolicy[index].mabTa) {
            // console.log('*/*/',Number(this.vamDetail.MablaghVam.replace(/,/g, '').replace(/\./g, '')));
            // console.log('*----',this.ListNoePolicy[index]);
            this.ListNoePolicyFilter = []
            this.ListNoePolicyFilter = this.ListNoePolicy[index]
          }
        }
      }

      // console.log(this.ListNoePolicyFilter);
    },
    seLectVam(item) {
      ;(this.ListCodeMeli = []), (this.ListZamen = []), (this.attachment = null), (this.ListTaahodat = []), (this.ListAzaHesab = []), (this.ListNoePolicy = null), (this.ListNoePolicyFilter = null), (this.lines = []), (this.linesattachment = [])
    
      var formdata = new FormData()
      formdata.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formdata.append('wwwtblNoeId', item.id)

      this.DataActionVamCondition.ArryfildValue = formdata
      this.$PostFormData(this.DataActionVamCondition)
        .then((res) => {
          switch (res.id) {
            case 0:
              this.SelectedVam = item
              if (this.$session.get('CustCode') == '801') {
                this.vamDetail.TedadGhest = 0
                this.vamDetail.MablaghVam = 0
                this.vamDetail.Mablaghghest = 0
              } else {
                this.vamDetail.MablaghVam = this.SelectedVam.minMablagh > 0 ? this.$Comma3ragham(this.SelectedVam.minMablagh) : 0
                this.vamDetail.Mablaghghest = this.SelectedVam.minTedad > 0 ? this.$Comma3ragham(this.SelectedVam.minTedad) : 0
                this.vamDetail.TedadGhest = this.SelectedVam.minTedad
              }
              this.lines = this.SelectedVam.des != '' ? this.SelectedVam.des.split('\n') : null
              this.linesattachment = this.SelectedVam.desUpload != '' ? this.SelectedVam.desUpload.split('\n') : null

              var formdata = new FormData()
              formdata.append('id', this.SelectedVam.settingId)
              this.DataAxiosZamenPolicy.ArryfildValue = formdata
              this.$PostFormData(this.DataAxiosZamenPolicy)
                .then((res) => {
                  this.ListNoePolicy = res
                  // console.log(this.ListNoePolicy);
                })
                .finally(() => {
                  this.UpdateZamenPolicy()
                })
              break
            case 1:
              this.$mySweetDefault('هشدار', 'سابقه عضویت شما جهت درخواست وام کافی نمیباشد.', 'warning', 3000)
              break
            case 2:
              this.$mySweetDefault('هشدار', 'سقف بودجه ماهیانه به اتمام رسیده است.', 'warning', 3000)
              break
            case 3:
              this.$mySweetDefault('هشدار', 'موجودی حساب شما جهت درخواست وام کمتر از سقف تایید شده میباشد.', 'warning', 3000)
              break
            case 4:
              this.$mySweetDefault('هشدار', 'به علت عدم رعایت سقف بدهی قبلی از این نوع وام شما مجاز به ثبت درخواست نمیباشید.', 'warning', 3000)
              break
            case 5:
              this.$mySweetDefault('هشدار', 'به علت عدم رعایت محدوده روز درخواست مجاز به ثبت درخواست نمیباشید.', 'warning', 3000)
              break
            case 6:
              this.$mySweetDefault('هشدار', 'این تسهیلات پیش از این توسط شما درخواست داده شده است.', 'warning', 2000)
              break
            default:
              this.$mySweetDefault('خطا', 'پاسخی از سرور دریافت نشد.', 'error', 2000)
              break
          }
        })
        .finally(() => {})
      //this.SelectedVam=item
    },
    clickUploader() {
      document.getElementById('attachmentUploader').click()
    },
    changeattach() {
      this.attachment = document.getElementById('attachmentUploader').files[0]
      if (this.attachment.size / 1000000 > 5) {
        this.$mySweetDefaultTost('هشدار', 'حجم فایل نمیتواند بیش از 5 مگابایت باشد', 'error', 3000)
        document.getElementById('attachmentUploader').value = null
        this.attachment = null
      }
    },
  },
}
</script>
<style scoped>
.hoverHeader:hover {
  font-weight: bold;
  color: darkorchid;
  background: rgb(224, 221, 226);
  cursor: pointer;
  transition: all 0.5s ease-in;
}
/* .hoverHeader{
    border-radius: 11% 89% 12% 88% / 94% 0% 100% 6%  ;
    -webkit-box-shadow: 0px 0px 15px -6px rgba(202,202,202,0.72); 
    box-shadow: 0px 0px 15px -6px rgba(202,202,202,0.72);

} */
.hoverHeader.current {
  font-weight: bold;
  color: #435ebe;
  background: #dee3f5;
  cursor: pointer;
  transition: all 0.5s ease-in;
}

.blueback {
  width: 100%;
  min-height: 80px;
  background: rgb(184, 218, 235);
  border: 2px dotted #3161e7;
  border-radius: 15px;
}

.yellowback {
  width: 100%;
  min-height: 80px;
  background: rgb(208, 224, 118);
  border: 2px dotted #929c04;
  border-radius: 15px;
}

.Uploader {
  width: 100%;
  height: 100%;
  border: 2px dashed #0c6ec9 !important;
  border-radius: 8px;
}
.Uploader:hover .fa-file-import {
  color: #0c6ec9 !important;
  transition: 0.3s;
}
</style>
